import { Card } from "./Card";

import "./CardItem.scss";

export namespace CardItem {
	export type Data = {
		title: string;
		content: string | (() => JSX.Element | JSX.Element[]);
	};
	export type Options = {
		layout?: "vertical" | "horizontal";
		span?: "max";
		align?: "left" | "center" | "right";
	};
	export type Props = {
		options: Options;
		data: Data;
	};
}
export class CardItem extends Card<CardItem.Props> {

	override get cls() {
		return {
			...super.cls,
			CardItem: true,
			[`layout-${this.props.options.layout ?? "vertical"}`]: true,
			[`span-${this.props.options.span ?? "normal"}`]: !!this.props.options.span,
			[`align-${this.props.options.align ?? "center"}`]: true
		};
	}

	public override render() {
		const dateOptions: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };

		const content = this.props.data.content;
		return (
			<div class={this.cls} style={this.props.style}>
				<div class="container">
					<h2 class="title">{this.props.data.title}</h2>
					<p class="excerpt">
						{typeof content === "string" ? content : content()}
					</p>
				</div>
			</div>
		);
	}
}
